import { render, staticRenderFns } from "./_policy-tables-configure.vue?vue&type=template&id=05ed5881"
import script from "./_policy-tables-configure.vue?vue&type=script&lang=js"
export * from "./_policy-tables-configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports